/**
 **********************************************
 * SHOPPING CART
 **********************************************
 */
ShoppingCart = function (_settings) {
    this.create(_settings || {});
}
///////////////////////////////////
// CART PRIVATE attribs and methods
ShoppingCart.prototype= {
    _wsUrl: API_URL,
    _orderUrl: null,
    _releases: {},
    _channels: [],
    _currency: '?',
    _subtotal: 0,
    _defaultReleaseImg: null,
    _editable: true,
    _roundToDecimals: 2,
    create: function(_settings) {
        this.settings = _settings;
        // the user id
        this.uid= _settings.uid;
        if (_settings.order == null || typeof _settings.order == undefined) _settings.order= []
        this.order = _settings.order;
        if (_settings.container == null || typeof _settings.container == undefined) throw "The 'container' parameter is mandatory and should be a DOM element."
        this._container= _settings.container;
        this._orderUrl= '/api/1.0/current_orders/' + this.uid;
        this._defaultReleaseImg = _settings.default_release_img;
        if (_settings.taxes != null && typeof _settings.taxes != undefined) {
            this._taxes = _settings.taxes;
        }
        if (_settings.roundToDecimals != null && typeof _settings.roundToDecimals != undefined) {
            this._roundToDecimals = _settings.roundToDecimals;
        }
        if (_settings.currency != null && typeof _settings.currency != undefined) {
            this._currency = _settings.currency;
        }
        if (_settings.editable != null && typeof _settings.editable != undefined) {
            this._editable = _settings.editable;
        }
        if (_settings.channel_selector != null && typeof _settings.channel_selector != undefined) {
            _settings.channel_selector.setCart(this);
        }

        this.releaseCache = _settings.releaseCache;
        this.channelCache = _settings.channelCache;

        this.render();
    },
    render: function() {
        this._container.addClass('half-width');

        var header = "<h2 class='float_left'>" + _T('In your cart') + ": </h2>";

        var self = this;
        var href = this._wsUrl + 'current_orders/' + this.uid;

        var table ="<br class='break'/><br/>\
<table>\
    <thead>\
        <tr>\
            <th class='release-col'>" + _T('Release') + "</th>\
            <th class='channel-col'>" + _T('Channel') + "</th>\
            <th class='type-col'>" + _T('Type') + "</th>\
            <th class='cost-col'>" + _T('Cost') + "</th>\
" + (this._editable ? "<th id='action-col'></th>" : "") + "\
        </tr>\
    </thead>\
    <tbody></tbody>\
</table>";

        if (this._editable) {
            var deleter = $('<a id="empty_order" role="button"></a>')
                .attr('href', href)
                .text(_T('Empty order'))
                .addClass('std-button ui-state-default warning float_right')
                .on('click', function (event) {
                    event.stopPropagation();
                    $.ajax(event.target.href, {type: 'DELETE'})
                        .fail(function (jqXHR, text, error) {
                            alert(text);
                        })
                        .done(function () {
                            self.refresh(true);
                        });

                    return false
                });

            this._container.prepend(header, deleter, table);
        } else {
            this._container.prepend(header, table);
        }

    },
    _render_audio_management: function (_item, _container) {
        var item_subtotal = new Number(round_number(_item.amount, this._roundToDecimals));
        _container.append($("\
<tr>\
<td colspan='3'>" + _T('audio management from %s to %s, %s min/month', [_item.from, _item.to, round_number(_item.units, this._roundToDecimals)]) + "</td>\
<td class='cost-col cost'>" + item_subtotal.toFixed(this._roundToDecimals) + this._currency + "</td>\
</tr>"));

        this._subtotal += item_subtotal;
    },
    /**
     * Renders and computes the costs for the given order item.
     */
    _processOrderItem: function(_item, _container) {
        if (!isset(_item.release_id)) {
            if (_item.type == 'AUDIO_MANAGEMENT') {
                this._render_audio_management(_item, _container);
            }

            return;
        }

        var itemSubtotal= 0;

        // prepare release data
        var release = this.releaseCache.get(_item.release_id).attributes;
        var model = new ModelHelper(release.item, this.settings.release_types[release.item_type].toLowerCase() + 's');
        var releaseImage = model.getImage('cover', '40', 'release item');
        var releaseName  = $('<div class="item"></div>').append(model.getModelIcon({'padding-left': '4px'})).append(release.title + '<br/>(' + release.track_count + ' ' + _T('tracks') + ')');

        // row for each release, type and channel
        var self = this;
        var releaseTd;
        var row_count = 0;

        _.each(_.keys(this.settings.service_types), function(_action_type) {
            _.each(_item.actions[_action_type], function(_action) {
                row_count++;
                var tr= $('<tr></tr>')
                // create release col (with span when release data)
                if (releaseImage != null) {
                    releaseTd= $('<td class="item-info"></td>').append(releaseImage).append(releaseName)
                    tr.append( releaseTd )
                    releaseImage= null;
                    releaseName= null;
                }
                self._renderChannel(_action_type, _action, release, tr);
                itemSubtotal+= new Number(_action.price_u) * release.track_count
                _container.append(tr)
            });});

        if (_item.actions.assign_isrc) {
            row_count++;
            var price_u = round_number(_item.actions.assign_isrc.price_u, this._roundToDecimals);
            itemSubtotal += price_u * _item.actions.assign_isrc.tracks;
            _container.append($("\
<tr>\
  <td>" + _T('assign_isrc_on_shopping_cart') + ' (' + price_u.toFixed(this._roundToDecimals) + this._currency + '/' + _T('track') + ")</td>\
  <td class='type-col'>" + _item.actions.assign_isrc.tracks + "</td>\
  <td class='cost-col cost'>" + round_number(_item.actions.assign_isrc.tracks * price_u, 2).toFixed(2) + this._currency + "</td>\
</tr>"));
        }

        if (_item.actions.assign_ean13) {
            row_count++;
            var price_u = round_number(_item.actions.assign_ean13, this._roundToDecimals);
            itemSubtotal += price_u;
            _container.append($("\
<tr>\
  <td colspan='2'>" + _T('assign_ean13_on_shopping_cart') + "</td>\
  <td class='cost-col cost'>" + price_u.toFixed(2) + this._currency + "</td>\
</tr>"));
        }

        if (_item.actions.assign_cat_no) {
            row_count++;
            var price_u = round_number(_item.actions.assign_cat_no, this._roundToDecimals);
            itemSubtotal += price_u;
            _container.append($("\
<tr>\
  <td colspan='2'>" + _T('assign_cat_no_on_shopping_cart') + "</td>\
  <td class='cost-col cost'>" + price_u.toFixed(2) + this._currency + "</td>\
</tr>"));
        }

        if (serviceUploadOnly = _item.actions.upload_only || _item.actions.upload_only_ringtone) {
            row_count++;
            var price_u = round_number(serviceUploadOnly.price_u, this._roundToDecimals);
            itemSubtotal += price_u * serviceUploadOnly.tracks;
            _container.append($("\
<tr>\
  <td>" + _T('track_upload_only_on_shopping_cart') + ' (' + price_u.toFixed(2) + this._currency + '/' + _T('track') + ")</td>\
  <td class='type-col'>" + serviceUploadOnly.tracks + "</td>\
  <td class='cost-col cost'>" + round_number(serviceUploadOnly.tracks * price_u, this._roundToDecimals).toFixed(this._roundToDecimals) + this._currency + "</td>\
</tr>"));
        }

        if (serviceQcOnly = _item.actions.qc_only || _item.actions.qc_only_ringtone) {
            row_count++;
            var price_u = round_number(serviceQcOnly.price_u, this._roundToDecimals);
            itemSubtotal += price_u * serviceQcOnly.tracks;
            _container.append($("\
<tr>\
  <td>" + _T('track_qc_only_on_shopping_cart') + ' (' + price_u.toFixed(this._roundToDecimals) + this._currency + '/' + _T('track') + ")</td>\
  <td class='type-col'>" + serviceQcOnly.tracks + "</td>\
  <td class='cost-col cost'>" + round_number(serviceQcOnly.tracks * price_u, this._roundToDecimals).toFixed(this._roundToDecimals) + this._currency + "</td>\
</tr>"));
        }

        releaseTd.attr('rowspan', row_count);

        // create subtotal row
        this._subtotal+= itemSubtotal
        _container.append($("\
<tr class='subtotal'>\
  <td colspan='3'>" + _T('subtotal') + ': ' + "</td>\
  <td class='cost-col cost'>" + round_number(itemSubtotal, this._roundToDecimals).toFixed(this._roundToDecimals) + this._currency + "</td>\
</tr>"));

    },
    /**
     * @param _action_type One of: 'deliver', 'update', 'takedown'
     * @param _item action data.
     * @param _action Order's channel.
     * @param _tr The TR in which this channel should be rendered.
     **/
    _renderChannel: function(_action_type, _action, _release, _tr) {

        if(_action_type != 'takedown'){
            this._channels.push(_action.channel_id);
        }

        // create channels col
        var model= new ModelHelper(this.channelCache.get(_action.channel_id).attributes, 'channels')
    	var image = model.getImage('logo', '40', 'channel item')
        _tr.append( $('<td class="item-info"></td>')
            .append(image)
            .append($("<div class='item'>" + model.shortened('name') + '<br/>' + "("+round_number(_action.price_u, this._roundToDecimals).toFixed(this._roundToDecimals) + this._currency + '/' + _T('track') + ')' + "</div>")));
        // create type col
        _tr.append( $('<td class="type-col ch_anchor"><a class="ch_target" href="#">' + this.settings.service_types[_action_type].toUpperCase() + '</a><div class="ch" id="tooltip_cart_order_type"></div></td>'));
        // create cost col
        _tr.append( $('<td class="cost-col cost">' + round_number(_action.price_u * _release.track_count, this._roundToDecimals).toFixed(this._roundToDecimals) + this._currency + '</td>'));

        if (this._editable) {
            var href= this._wsUrl + 'current_orders/' + this.uid + '/releases/' + _release.id + '/channel/' + _action.channel_id
            var self= this
            var deleter= $('<a href="' + href + '" class="icon delete"></a>').click(function(event) {
                event.stopPropagation()
                $.ajax(event.target.href, { type: 'DELETE' })
                    .fail(function(jqXHR, text, error) { alert(text); })
                    .done(function() { self.refresh(); });

                return false
            })
            _tr.append( $('<td></td>').append( $('<center></center>').append( deleter ) ) )
        }
    },
    _renderTotals: function(_container) {
        if (this._subtotal > 0) {
            _container.append("\
            <tr class='total'>\
              <td colspan='3'>" + _T('resume') + ":</td>\
              <td class='cost-col cost'>" + round_number(this._subtotal, this._roundToDecimals).toFixed(this._roundToDecimals) + this._currency + "</td>\
            </tr>");

            // total vat
            for (i = 0; i < this._taxes.length; i++) {
                _container.append("\
                <tr class='total'>\
                  <td colspan='3'>" + this._taxes[i].tax_name + " (" + this._taxes[i].rate + "%):</td>\
                  <td class='cost-col cost'>" + this.calculateTax(this._taxes[i]) + this._currency + "</td>\
                </tr>");
            }
        }

        // total amount
        _container.append("\
<tr class='grandtotal'>\
  <td colspan='3'>" + _T('total') + ":</td>\
  <td class='cost-col cost'>" + round_number(this.calculateTotalWithTaxes(), this._roundToDecimals).toFixed(this._roundToDecimals) + this._currency + "</td>\
</tr>");
    },
    _reset: function() {
        this._subtotal= 0;
    },
    empty: function() {
        return _.isEmpty(this.order.order);
    },
    add: function(_releases, _channels) {
        if (!this._editable) {
            return;
        }

        var self= this;
        $.post(this._wsUrl + 'current_orders/' + this.uid, JSON.stringify([{ releases: _releases, channels: _channels }]))
            .fail(function(_xhr, _text, _error) {
                alert(_.reduce(new ApiResponse(JSON.parse(_xhr.responseText)).getMsgs(), function(_memo, _item) { return _memo + _item + "\n"; }, ''));
                return false;
            })
            .done(function() {
                self.refresh(true);
                return false;
            });
    },
    _onData: function(_order) {
        this.order = _order;

        var releasesIds = [];
        var channelsIds = [];

        var self = this;

        _.each(this.order.order, function(_order) {

            if(!_order.release_id) {
                return false;
            }

            releasesIds.push(_order.release_id);
            _.each(_.keys(self.settings.service_types), function(_action_type) {
                _.each(_order.actions[_action_type], function(_channel) {
                    channelsIds.push(_channel.channel_id);
                });
            });
        });

        $.when(this.releaseCache.fetch({ add: true, ids: releasesIds }),
            self.channelCache.fetch({ add: true, ids: channelsIds }))
            .always(function() {
                self._renderCart();
            });
    },
    _updateState: function() {
        if (this.settings.order) {
            this._onData(this.settings.order);
            delete(this.settings.order);
        } else {
            var self = this;
            $.ajax(this._orderUrl, { async: false })
                .fail(function(jqXHR, text, error) { alert(text); })
                .done(function(_order) {
                    self._onData(_order);
                });
        }
    },
    _renderCart: function() {
        var self = this;
        var container = $('<tbody></tbody>');
        this._channels = [];
        _.each(this.order.order, function(orderItem) {
            self._processOrderItem(orderItem, container);
        });
        this._renderTotals(container);

        this._container.find('tbody').remove();
        this._container.find('table').append(container);
        if (this.settings.afterUpdate) {
            this.settings.afterUpdate(this);
        }
    },
    refresh: function() {
        this._reset();

        this._updateState();
    },
    editable: function(editable) {
        this._editable = editable;
    },
    getChannels: function() {
        return _.uniq(this._channels);
    },
    calculateTotalWithTaxes: function () {
        var result = this._subtotal;

        for (var i = 0; i<this._taxes.length; i++) {
            result = result + this.calculateTax(this._taxes[i]);
        }

        return result.toFixed(this._roundToDecimals);
    },
    calculateTax: function (tax) {
        var total = this._subtotal * tax.rate / 100;
        var sign = (total < 0 ? -1 : 1);

        return sign * Math.round(Math.abs(total) * 100) / 100;
    }
};
